import { useEffect, useState } from 'react'

/**
 * Counts down from a number of seconds and stops at zero.
 * Returns the formatted mm:ss string plus the raw remaining seconds.
 */
export function useCountdown(initialSeconds: number) {
  const [remaining, setRemaining] = useState(initialSeconds)

  useEffect(() => {
    if (remaining <= 0) return
    const id = window.setInterval(() => {
      setRemaining((prev) => (prev <= 1 ? 0 : prev - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [remaining])

  const hours = Math.floor(remaining / 3600)
  const minutes = Math.floor((remaining % 3600) / 60)
  const seconds = remaining % 60
  const pad = (value: number) => String(value).padStart(2, '0')

  return {
    remaining,
    formatted: `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`,
    isExpired: remaining === 0,
  }
}
